import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./components/Dashboard/Dashboard";
import Territories from "./components/Territories/Territories";
import Report from "./components/Reports/Report";
import Notification from "./components/Notifications/Notification";
import Account from "./components/Accounts/Account";
import Request from "./components/Requests/Request";
import TerritoriesShow from "./components/Territories/TerritoriesShow";
import ReportsShow from "./components/Reports/ReportsShow";
import Login from "./components/Login/Login";
import Authlayout from "./layout/Authlayout";
import Mainlayout from "./layout/Mainlayout";
import Manager from "./components/Managers/Manager";
import Expenses from "./components/Expenses/Expenses";
import Logbooks from "./components/Logbooks/Logbooks";
import Farmers from "./components/Farmers/Farmers";
import Demos from "./components/Demos/Demos";
import FMFD from "./components/FMFD/FMFD";
import Plannings from "./components/Plannings/Plannings";
import FSOMonthly from "./components/FSOMonthly/FSOMonthly";
import AreaVisits from "./components/AreaVisits/AreaVisits";
import FMFDCoaching from "./components/FMFDCoaching/FMFDCoaching";
import SalesCoaching from "./components/SalesCoaching/SalesCoaching";
import Cookies from 'js-cookie'; 
import Table from "./components/Table/Table";
import Vehicles from "./components/Vehicles/Vehicles";
import AddVehicle from "./components/Vehicles/AddVehicle";
import UpdateVehicle from "./components/Vehicles/UpdateVehicle";
import TravelReport from "./components/Travel/TravelReport";

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isAuthChecked, setIsAuthChecked] = useState(false);
    const [show, setShow] = useState(false);

    // Check authentication status based on the presence of the JWT cookie
    useEffect(() => {
        const authToken = Cookies.get('authToken');
        if (authToken) {
            setIsAuthenticated(true); // User is authenticated
        }
        setIsAuthChecked(true); // Auth check is complete
    }, []);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    if (!isAuthChecked) {
        return null; // or a loading spinner, or any placeholder
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route element={<Authlayout />}>
                    <Route path="/login" element={<Login onLogin={() => setIsAuthenticated(true)} />} />
                    <Route path="*" element={isAuthenticated ? <Navigate to="/" replace /> : <Navigate to="/login" replace />} />
                </Route>
                {isAuthenticated && (
                    <Route element={<Mainlayout handleShow={handleShow} handleClose={handleClose} show={show} />}>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/territories" element={<Territories />} />
                        <Route path="/territories/show" element={<TerritoriesShow />} />
                        <Route path="/managers" element={<Manager />} />
                        <Route path="/logbooks" element={<Logbooks />} />
                        <Route path="/farmers" element={<Farmers />} />
                        <Route path="/demos" element={<Demos />} />
                        <Route path="/fmfd" element={<FMFD />} />
                        <Route path="/plannings" element={<Plannings />} />
                        <Route path="/expenses" element={<Expenses />} />
                        <Route path="/fsomonthly" element={<FSOMonthly />} />
                        <Route path="/areavisits" element={<AreaVisits />} />
                        <Route path="/fmfdcoaching" element={<FMFDCoaching />} />
                        <Route path="/salescoaching" element={<SalesCoaching />} />
                        <Route path="/reports/show/:id" element={<ReportsShow />} />
                        <Route path="/reports" element={<Report />} />
                        <Route path="/notifications" element={<Notification />} />
                        <Route path="/accounts" element={<Account />} />
                        <Route path="/requests" element={<Request />} />
                        <Route path="/vehicles" element={<Vehicles />} />
                        <Route path="/vehicles" element={<Vehicles />} />
                        <Route path="/report" element={ <TravelReport/>} />
                        <Route path="/addVehicle" element={<AddVehicle/>} />
                        <Route path="/updateVehicle/:id" element={<UpdateVehicle/>} />
                        <Route path="/table" element={<Table/>} />
                    </Route>
                )}
            </Routes>
        </BrowserRouter>
    );
}

export default App;
